import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TooltipDirective, TooltipPosition } from '@directives';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-long-string-column',
  standalone: true,
  imports: [TooltipDirective],
  templateUrl: './long-string-column.component.html',
  styleUrl: './long-string-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LongStringColumnComponent implements AgRendererComponent {
  readonly value = signal<string>('');
  readonly tooltipPosition = signal<TooltipPosition>('top');

  agInit(params: ICellRendererParams): void {
    const colName = (params as ICellRendererParams & { colName?: string }).colName!;
    this.value.set(params.data[colName] || '');
  }
  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
